module.exports = __webpack_public_path__ + "img/ferrim.eec00610.png";